// Generated by Copilot

import { useNavigate } from "react-router";

import { RichContentRenderer } from "@/components/helpers/ui/RichContentRenderer";
import { Box } from "@/components/layout/flexbox";
import { isComponentInProgressOrOverdue } from "@/components/pages_logged_in/program/components/componentMetadata";
import { Button } from "@/components/ui/button";
import {
  ProgramComponentsQueryDocument,
  ProgramSurveyQueryDocument,
  useSaveProgramSurveyAnswerMutation,
} from "@/graphql";
import { PanelProps } from "@/types/programs";

export function ProgramAnnouncementItemPanel({
  component,
  program,
  role = "participant",
  view = "list",
}: PanelProps) {
  const navigate = useNavigate();
  const { body, status } = component || {};
  const isProgramLead = role === "lead";
  const isDismissable =
    !isProgramLead && isComponentInProgressOrOverdue(status);
  const formFields = component?.survey?.formFields || [];
  const mainFormField = formFields?.[0] || null;

  const [saveProgramSurveyAnswer, { loading: savePending }] =
    useSaveProgramSurveyAnswerMutation({
      refetchQueries: [
        {
          query: ProgramSurveyQueryDocument,
          variables: { programSurveyId: component?.survey?.id },
        },
        {
          query: ProgramComponentsQueryDocument,
          variables: { programId: program?.id },
        },
      ],
      awaitRefetchQueries: true,
    });

  const _onSubmitAnswerHandler = (fieldId?: string, value?: string) => {
    saveProgramSurveyAnswer({
      variables: {
        surveyId: component.survey?.id || "",
        answerData: {
          value,
          fieldId,
        },
      },
    });
  };

  if (view === "feed") {
    return (
      <div className="xs:p-3.5 xs:rounded-md xs:gap-3 flex flex-col bg-gradient-to-br from-[#F2FAFF] to-[#D8ECF8] md:gap-4 md:rounded-lg md:p-6">
        <div className="text-lg font-semibold text-blue-800">
          You have an announcement to read
        </div>
        <div>
          <Button
            className="xs:px-7 xs:py-2.5 md:px-12 md:py-3"
            onClick={() =>
              navigate(`/programs/${program.id}#component_id_${component.id}`)
            }
            variant="solid"
            intent="primary"
            size="lg"
          >
            <span className="xs:text-sm font-semibold md:text-base">
              Go to Program
            </span>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <Box className="xs:gap-3.5 flex flex-col md:gap-4 empty:hidden">
      {body ? <RichContentRenderer content={body} /> : null}

      {isDismissable && (
        <div>
          <Button
            className="bg-[#0719560A] text-sm shadow-none"
            variant="outline"
            intent="secondary"
            disabled={savePending}
            onClick={() => {
              _onSubmitAnswerHandler(mainFormField?.id, `true`);
            }}
          >
            Dismiss
          </Button>
        </div>
      )}
    </Box>
  );
}
